import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { FnLoaderComponent } from './loader.component';
import { FnLoaderService } from './loader.service';
import { LoaderInterceptor } from './loader.interceptor';

export * from './loader.component';
export * from './loader.service';
export * from './loader.interceptor';

/**
 * Export FnLoaderComponent for Showing Loader
 * And Provide FnLoaderService to set the default Configuration for loader for whole application.
 * making them available for import by NgModules that import this module.
 * This Module Can be available For whole application by importing as .root() and Also for Child Modules by imporing module.
 */
@NgModule({
  declarations: [FnLoaderComponent],
  imports: [
    CommonModule
  ],
  exports: [
    FnLoaderComponent
  ],
  providers: [
    FnLoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    }
  ]
})
export class FnLoaderModule {
  /**
   * Creates and configures a module for RootModule.
   * Use forRoot() only once in the application,
   */
  public static forRoot(): ModuleWithProviders<FnLoaderModule> {
    return {
      ngModule: FnLoaderModule,
      providers: [FnLoaderService]
    };
  }
  /**
   * Creates and configures a module for Child Modules.
   * You can use forChild() in multiple modules.
   */
  public static forChild(): ModuleWithProviders<FnLoaderModule> {
    return {
      ngModule: FnLoaderModule,
      providers: [FnLoaderService]
    };
  }
}

